import { useCallback } from 'react'
import { createHashRouter, Link, LinkProps, useNavigate } from 'react-router-dom'

import Cashback from 'containers/Cashback'
import GameView from 'containers/GameView'
import Knights from 'containers/RoundTableKnights'
import Seat from 'containers/RoundTableKnights/Seat'

export const HOME_LINK = '/'
export const CASHBACK_LINK = '/cashback'
export const KNIGHTS_LINK = '/knights'

type RoutedLinkProps = Omit<LinkProps, 'to'>

export const LinkHome = (props: RoutedLinkProps) => (
  <Link {...props} to={HOME_LINK} />
)
export const LinkCashback = (props: RoutedLinkProps) => (
  <Link {...props} to={CASHBACK_LINK} />
)
export const LinkKnights = (props: RoutedLinkProps) => (
  <Link {...props} to={KNIGHTS_LINK} />
)

export const routers = createHashRouter([
  {
    path: HOME_LINK,
    element: <GameView />,
    errorElement: <div>404</div>
  },
  {
    path: CASHBACK_LINK,
    element: <Cashback />,
  },
  {
    path: KNIGHTS_LINK,
    element: <Knights />,
    children: [
      {
        path: ':id',
        element: <Seat />,
      },
    ],
  },
])

export default routers

export const useNavHome = () => {
  const nav = useNavigate()
  return useCallback(() => nav(HOME_LINK), [nav])
}

export const useNavKnights = () => {
  const nav = useNavigate()
  return useCallback(() => nav(KNIGHTS_LINK), [nav])
}

export const useNavCashback = () => {
  const nav = useNavigate()
  return useCallback(() => nav(CASHBACK_LINK), [nav])
}
